import { useEffect, useRef } from "react";

type TranscriptionsTranscriptionVideoProps = React.ComponentProps<"video"> & {
	currentTime?: number;
};

const TranscriptionsTranscriptionVideo = ({
	currentTime,
	...props
}: TranscriptionsTranscriptionVideoProps) => {
	const videoRef = useRef<HTMLVideoElement>(null);

	useEffect(() => {
		if (videoRef.current && currentTime) {
			videoRef.current.currentTime = currentTime;

			videoRef.current?.play();
		}
	}, [currentTime]);

	return (
		<video
			className="aspect-video rounded"
			ref={videoRef}
			{...props}
			controls
		/>
	);
};

export { TranscriptionsTranscriptionVideo };
